// import './js/navigation';
import 'pagedone/src/js/pagedone';
import Tooltips from './js/Tooltips';
import SmoothAnchors from './js/SmoothAnchors';
import GazSimulation from './js/GazSimulation';

document.addEventListener('DOMContentLoaded', function (e) {
	Tooltips.init();
	GazSimulation.init();
	SmoothAnchors.bindEvents();
});

/* QUICK FIX anim lottie "Thermomètre" */
const player = document.querySelector('.wp-block-acf-facts .paragraphs .paragraph:nth-child(4) dotlottie-player');
player.addEventListener('ready', () => {
	setInterval(() => {
		player.stop();
		player.play();
	}, 4000);
});